<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_up"
      persistent
      :max-width="width"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x-small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 pb-0">
          <v-container style="height: max-content">
            <post-up
              :inventory="inventory"
              v-if="type == 'up'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
            <delete-up
              :inventory="inventory"
              v-if="type == 'del_up'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
            <UpdateTxtUP
              :inventory="inventory"
              v-if="type == 'up_txt'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
            <update-medsos
              :inventory="inventory"
              v-if="type == 'up_medsos'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
            <post-contact-person-up
              :inventory="inventory"
              v-if="type == 'up_cp'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
            <post-sector-up
              :inventory="inventory"
              v-if="type == 'up_sector'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
            <cropper
              :inventory="inventory"
              v-if="type == 'crop'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
            <cropper-cover
              :inventory="inventory"
              v-if="type == 'crop_cover'"
              @success="closeAndFetch"
              @close="$emit('close')"
            />
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Cropper from "./cropper.vue";
import CropperCover from "./cropperCover.vue";
import DeleteUp from "./deleteUp.vue";
import PostContactPersonUp from "./postContactPersonUp.vue";
import postUp from "./postUp.vue";
import PostSectorUp from "./Sector/postSectorUp.vue";
import UpdateMedsos from "./updateMedsos.vue";
import UpdateTxtUP from "./updateTxtUP.vue";
export default {
  components: {
    postUp,
    DeleteUp,
    UpdateTxtUP,
    UpdateMedsos,
    PostContactPersonUp,
    PostSectorUp,
    Cropper,
    CropperCover,
  },
  name: "dialogUP",
  props: ["d_up", "type", "title", "inventory", "width"],
  methods: {
    
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>